module.exports = __webpack_public_path__ + "img/imgwelcome.a6e443b1.webp";